const CDN = {
  css:        'https://cdn.jsdelivr.net/npm/@splidejs/splide@4.1.4/dist/css/splide.min.css',
  js:         'https://cdn.jsdelivr.net/npm/@splidejs/splide@4.1.4/dist/js/splide.min.js',
  autoScroll: 'https://cdn.jsdelivr.net/npm/@splidejs/splide-extension-auto-scroll@0.5.3/dist/js/splide-extension-auto-scroll.min.js',
};

export async function loadSplideCSS()        { await window.siteLoadOnce(CDN.css); }
export async function loadSplide()           { await window.siteLoadOnce(CDN.js,         { defer: true }); }
export async function loadSplideAutoScroll() { await window.siteLoadOnce(CDN.autoScroll, { defer: true }); }
